import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { Button, Modal } from "antd";
import { TopBreadcrumb } from "@/layouts/TopBreadcrumb";
import { useParams, useSearchParams } from "react-router-dom";
import { AddonVersionEditor } from "./AddonVersionEditor";
import { AddonVersionCreator } from "./AddonVersionCreator";
import { AddonEditor } from "./editor";
import { ImportAddon } from "./import";
import { ExportAddon } from "./export";

export const EDIT_VERSION = "editVersion";
export const CREATE_VERSION = "createVersion";
export const CREATE_ADDON = "create";
export const EDIT_ADDON = "edit";
export const EXPORT_ADDON = "export";
export const IMPORT_ADDON = "import";


export const AddonRoute = ({ goto }) => {
  const [searchParams] = useSearchParams();  
  const { action, id } = useParams();
  const navigate = useResourceNavigate();
  const onLaunchInstance = (e) => {
    e.preventDefault();
    navigate({ resource: goto, action: "list" });
  };

  if (action === EDIT_VERSION) {
    const version = searchParams.get("version");
    return <AddonVersionEditor id={id} goto={goto} version={version}/>;
  } if (action === CREATE_VERSION) {
    const version = searchParams.get("version");
    return <AddonVersionCreator id={id} goto={goto} version={version}/>;
  } else if( action === EXPORT_ADDON) {
    return <div><TopBreadcrumb /><ExportAddon id={id}/></div>;
  } else if( action === IMPORT_ADDON) {
    return <div><TopBreadcrumb /><ImportAddon id={id}/></div>;
  } else if( action === EDIT_ADDON ) {
    return <AddonEditor id={id} />;
  } else {
    return (
      <div>
        <TopBreadcrumb />
        <h1>Action: {action}</h1>
        <p>InstanceId: {id}</p>
        <Button onClick={onLaunchInstance}>Cancel</Button>
      </div>
    );
  }
};
